<template>
    <Confirm ref="confirmDialog" />
    <!-- <confirm-delete ref="confirmDelete" /> -->
</template>

<script>
import Confirm from '@/shared/components/Confirm'

export default {
    components: {
        Confirm,
    },

    methods: {
        async delete(model) {
            let confirmed = await this.$refs.confirmDialog.open(
                this.$t('actions.delete.title'),
                this.$t('actions.delete.text', {
                    name: '',
                }),
            )
            if (!confirmed) return

            await model.delete()

            this.$emit('modelChanged')
            this.$bus.$emit(
                'notify',
                'success',
                this.$t('actions.delete.success'),
            )
        },

        async restore(model) {
            let confirmed = await this.$refs.confirmDialog.open(
                this.$t('actions.restore.title'),
                this.$t('actions.restore.text', {
                    name: '',
                }),
            )
            if (!confirmed) return

            await model.restore()

            this.$emit('modelChanged')
            this.$bus.$emit(
                'notify',
                'success',
                this.$t('actions.restore.success'),
            )
        },
    },
}
</script>

<style></style>
